// extracted by mini-css-extract-plugin
module.exports = {"header":"DefaultLayout_header__3Q0z6","outer":"DefaultLayout_outer__2lTSY"};